import { useEffect, useState } from "react";
import { fetchPricing } from "../../lib/api";

export const DEFAULT_PRICING = { mode: "paid", unlock_fee: 200, placement_fee: 0, wallet_options: [5000, 10000], commission_rates: [500, 750, 1000] };

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const usePricing = () => {
  const [pricing, setPricing] = useState(DEFAULT_PRICING);
  useEffect(() => {
    fetchPricing().then(setPricing).catch(() => {});
  }, []);
  return pricing;
};
